// Vendor imports
const qs = require('qs')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
const articleProfileSlideActions = require('client-v2/common/containers/article-profile/state/slide-actions')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const articleModelActions = require('client-v2/common/models/article/actions')
// Entry imports
const rootFactory = require('./components/root').factory
const configureStore = require('./state/store')

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  commonClient.configureSession(store, {
    pageName: 'article.card'
  })

  const { articleProfile, user } = store.getState()

  store.dispatch(articleProfileSlideActions.slideDidBecomeVisible({
    slide: articleProfile
  }))

  const { action } = qs.parse(location.search, { ignoreQueryPrefix: true })
  if (action) {
    const { article } = articleProfile
    if (action === 'add') {
      if (user.loggedIn) {
        // Show a confirmation message before Mixing the post from an URL action
        (async () => {
          if (await store.dispatch(confirmModalActions.confirm({
            heading: 'Mix this post',
            subheading: 'Do you want to save this post to your profile?'
          }))) {
            document.querySelector('.ArticleMixButton').click()
          }
        })()
      } else {
        store.dispatch(authModalActions.showSignup())
      }
    }
    if (action === 'share') {
      store.dispatch(articleModelActions.showArticleShareModal({ article }))
    }
  }

})
